export default __webpack_public_path__ + "2e27b79641ee70757bda3ec9ceeaca46.png";